// Pour une documentation complète sur API, incluant des exemples de code, allez sur http://wix.to/94BuAAs

$w.onReady(function () {

//setTimeout(function(){ $w("#text109").show("puff") },1000);
//setTimeout(function(){ $w("#text109").hide() }, 4000);
//cleartimeout
//setTimeout(function(){ $w("#text108").show("puff") },2000);
//setTimeout(function(){ $w("#text108").hide() }, 4000);
//setTimeout(function(){ $w("#text107").show("puff") },3000);
//setTimeout(function(){ $w("#text107").hide() }, 4000);

});